import React from 'react'
import {actions} from 'react-redux-form'
import {toast} from 'react-toastify'
import qs from 'qs'
import irelandApi from '../irelandApi'
import store, {history} from '../store'
import ToastMessage from '../components/common/toast-message'

export const getMessages = (read) => (dispatch) => {
  dispatch({type: 'GET_MESSAGES_PENDING'});
  const query = {
    read: read
  };

  return irelandApi.get(`/api/messages?${qs.stringify({q: query}, {encodeValuesOnly: true})}`)
                   .then(function (response) {
                     dispatch({type: 'GET_MESSAGES_FULFILLED', payLoad: response.data});
                   })
                   .catch(function (error) {
                     dispatch({type: 'GET_MESSAGES_REJECTED', payLoad: error});
                   });
};

export const markMessagesAs = (type, ids) => (dispatch) => {
  dispatch({type: 'MARK_MESSAGES_PENDING'});

  return irelandApi.put(`/api/messages/${type}`, {messages: ids})
                   .then(function (response) {
                     dispatch({type: 'MARK_MESSAGES_FULFILLED', payLoad: {messageIds: ids, read: type === 'read'}});

                     toast.success(<ToastMessage iconStyle="success" message={`Messages has been marked as ${type}`}/>);
                   })
                   .catch(function (error) {
                     dispatch({type: 'MARK_MESSAGES_REJECTED', payLoad: error});

                     toast.error(<ToastMessage iconStyle="error" message={`An error occurred during marking messages as ${type}`}/>);
                     return Promise.reject(error.response.data);
                   });
};

export const deleteMessage = (id) => (dispatch) => {
  dispatch({type: 'DELETE_MESSAGES_PENDING'});

  return irelandApi.delete(`/api/messages/${id}`)
                   .then(function (response) {
                     dispatch({type: 'DELETE_MESSAGES_FULFILLED', payLoad: {messageIds: [id]}});

                     toast.success(<ToastMessage iconStyle="success" message={`Message has been successfully deleted`}/>);
                   })
                   .catch(function (error) {
                     dispatch({type: 'DELETE_MESSAGES_REJECTED', payLoad: error});

                     toast.error(<ToastMessage iconStyle="error" message={`An error occurred during deleting message`}/>);
                     return Promise.reject(error.response.data);
                   });
};

export const deleteMessages = (ids) => (dispatch) => {
  dispatch({type: 'DELETE_MESSAGES_PENDING'});

  return irelandApi.delete(`/api/messages_delete/`, {data: {messages: ids}})
                   .then(function (response) {
                     dispatch({type: 'DELETE_MESSAGES_FULFILLED', payLoad: {messageIds: ids}});

                     toast.success(<ToastMessage iconStyle="success" message={`Messages has been successfully deleted`}/>);
                   })
                   .catch(function (error) {
                     dispatch({type: 'DELETE_MESSAGES_REJECTED', payLoad: error});

                     toast.error(<ToastMessage iconStyle="error" message={`An error occurred during deleting messages`}/>);
                     return Promise.reject(error.response.data);
                   });
};


// WEBPACK FOOTER //
// ./src/actions/messages.js